import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Grid, Typography, Fade } from '@mui/material';
import TabButton from './tab-button';
import { TheoryProps } from '@/types/theories';
import { urlFor } from '@/utils/buildImageSource';

const MainDiv = styled.div``;
const ContentDiv = styled(Grid)`
  width: 100%;
  height: 600px;
  padding: 0 12.5%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const TransitionsGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const TheoryTitle = styled(Typography)`
  font-family: var(--font-cooper-light), sans-serif;
  font-weight: 300;
  font-size: 40px;
  line-height: 112.3%;
  text-align: center;
  color: #ffffff;
  width: 100%;
  margin-bottom: 50px;
  margin-top: 100px;
`;
const TheoriesButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: fit-content;
  background: #4c3b51;
  border-radius: 100px;
  padding: 9px;
  margin: 0 auto 100px auto;
`;
const ButtonText = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-weight: 600;
  font-size: 17px;
  margin: auto;
  line-height: 157.3%;
  text-align: center;
`;

const Star = styled.img`
  height: 20px;
  width: 19px;
  margin: 5px 16px;
`;
const DetailedTheoryTitle = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-weight: 500;
  font-size: 28px;
  line-height: 127.3%;
  color: #ffffff;
  margin-bottom: 20px;
`;
const TheoryText = styled(Typography)`
  font-size: 16px;
  font-family: var(--font-work-sans), sans-serif;
  line-height: 159.3%;
  color: #ffffff;
  text-align: start;
  margin-right: 40px;
  @media (max-width: 768px) {
    margin-right: 0;
  }
`;
const SideVector = styled.img`
  object-fit: cover;
  position: absolute;
  width: 30%;
  height: auto;
  right: 0;
  margin-top: -100px;
`;
const TheoryDiv = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  height: auto;
  z-index: 1;
  margin-bottom: 32px;
`;
const Video = styled.div`
  height: auto;
  width: 83.24%;
  position: relative;
  margin-left: 40px;
  @media (max-width: 768px) {
    height: auto;
    width: 100%;
    margin-left: 0;
  }
`;
const TheoryImage = styled.img`
  width: 100%;
  height: auto;
`;

const DesktopView = ({
  theories,
  archiveMode = false,
}: TheoryProps & { archiveMode?: boolean }) => {
  const [index, setIndex] = useState<number>(0);
  const [checked, setChecked] = useState<boolean>(true);
  const tabLabels = archiveMode
    ? ['Individuals & families', 'Organizations & funders', 'Community & culture']
    : ['Individuals & families', 'Organization & funders', 'Community & culture'];
  const handleOnClick = (index: number) => {
    setChecked(false);
    setTimeout(() => {
      setIndex(index);
      setChecked(true);
    }, 400);
  };

  return (
    <MainDiv>
      <TheoryTitle>Acting at three levels</TheoryTitle>
      <TheoriesButtons>
        <TabButton
          className={index === 0 ? 'active' : ''}
          onClick={() => handleOnClick(0)}
          size="medium"
        >
          <ButtonText>{tabLabels[0]}</ButtonText>
        </TabButton>
        <Star src="/about-us/toc/star.png" alt={'stars'} />
        <TabButton
          className={index === 1 ? 'active' : ''}
          onClick={() => handleOnClick(1)}
          size="medium"
        >
          <ButtonText>{tabLabels[1]}</ButtonText>
        </TabButton>
        <Star src="/about-us/toc/star.png" alt={'stars'} />
        <TabButton
          className={index === 2 ? 'active' : ''}
          onClick={() => handleOnClick(2)}
          size="medium"
        >
          <ButtonText>{tabLabels[2]}</ButtonText>
        </TabButton>
      </TheoriesButtons>

      <ContentDiv container>
        <SideVector src="/about-us/toc/vector1.png" />
        <Fade in={checked} unmountOnExit timeout={400}>
          <TransitionsGroup>
            <TheoryDiv item md={6}>
              <DetailedTheoryTitle>{theories[index].name}</DetailedTheoryTitle>
              <TheoryText>{theories[index].detail}</TheoryText>
            </TheoryDiv>
            <TheoryDiv item md={6}>
              <Video>
                <TheoryImage src={urlFor(theories[index].image)} />
              </Video>
            </TheoryDiv>
          </TransitionsGroup>
        </Fade>
      </ContentDiv>
    </MainDiv>
  );
};

export default DesktopView;
